<template>
	<div class="w-100 d-flex align-items-center">
		<div
			class=""
			:class="isLaptop ? 'mr-3' : ''"
			v-if="$route.name == 'CandidateDashboard' && !isParser"
		>
			<img
				class="drag-handleHobby"
				src="../../../assets/newdesign/dashboard/6dots.svg"
				alt=""
			/>
		</div>
		<div
			class="p-2 position-relative mob-align-items-start"
			:class="{
				'candash-red-details-box': isParser,
				'candash-blue-details-nowid': !isParser,
				'resume-builder-card-width':
					!isParser && $route.name === 'CandidateDashboard',
				'w-100': isParser || $route.name !== 'CandidateDashboard',
			}"
		>
			<div class="d-flex align-items-center">
				<img
					class="mr-3 lapicon"
					src="../../../assets/newdesign/dashboard/skillDp.svg"
					alt=""
				/>
				<img
					class="mr-2 mobicon"
					src="@/assets/newbuilder/mob-skills.svg"
					alt=""
				/>
				<div class="d-flex align-items-center justify-content-between w-100">
					<div
						class="bold-bluetxt mob-w-95 w85 pr-5"
						:class="hobby ? '' : 'not-mention-txt'"
					>
						{{ hobby ? hobby : "Not Mentioned" }}
					</div>

					<div class="laptop-ed-icons d-dlex align-items-center">
						<img
							@click.stop="openEdit()"
							class="mr-2 pointer blueShadow"
							src="../../../assets/newdesign/dashboard/blueEdit1.svg"
							alt=""
						/>
						<img
							@click="deleteData()"
							src="../../../assets/newdesign/dashboard/blueDelete1.svg"
							alt=""
							class="mr-2 pointer blueShadow"
						/>
						<img
							v-if="hobby.card"
							src="../../../assets/newdesign/dashboard/disableadd.svg"
							alt=""
						/>
					</div>
					<div class="mobile-ed-icons" @click="$emit('select-card', hobby)">
						<img src="@/assets/newbuilder/threedots.svg" alt="" />
						<div class="ed-box" v-if="selectedCard == hobby">
							<div
								class="ed-box-option d-flex align-items-center pl-2 pointer"
								@click.stop="openEdit()"
							>
								<img
									src="@/assets/newbuilder/ddedit.svg"
									class="mr-2"
									alt=""
								/>Edit
							</div>
							<div
								class="ed-box-option d-flex align-items-center pl-2 pointer"
								@click="deleteData()"
							>
								<img
									src="@/assets/newbuilder/delete.svg"
									class="mr-2"
									alt=""
								/>Delete
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "HobbyCard",
	props: {
		selectedCard: String,
		hobby: String,
		isLaptop: Boolean,
		formConfiguration: Object,
		form: Object,
		isParser: Boolean,
	},
	created() {},
	methods: {
		openEdit() {
			let form = {
				formID: "hobbies",
			};
			this.$emit("edit-form", {
				form: form,
				content: this.hobby,
				id: this.hobby,
			});
		},
		deleteData() {
			let form = {
				formID: "hobbies",
			};
			this.$emit("delete-data", {
				form: form,
				content: {
					hobby: this.hobby,
					isParser: this.isParser,
				},
			});
		},
	},
};
</script>

<style></style>
